export default __webpack_public_path__ + "static/media/frog-hooray.f81dc070.gif";